import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {
  transform(totalSeconds: number): string {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    // const seconds = totalSeconds % 60;

    const formattedHours = this.padNumber(hours, true);
    const formattedMinutes = this.padNumber(minutes);
    // const formattedSeconds = this.padNumber(seconds);

    return `${formattedHours}:${formattedMinutes}`;
  }

  private padNumber(num: number, isHours = false): string {
    if (isHours && num > 99) {
      return `${num}`;
    }
    return num < 10 ? `0${num}` : `${num}`;
  }
}
